import { useDates } from "../../../dates/DatesContext";
import { useFetch } from "../../../hooks/api";
import { HStack } from "../../../../styled-system/jsx";
import Card from "../../core/basic/Card";
import SummaryMetric from "../../core/blocks/SummaryMetric";
import { css } from "../../../../styled-system/css";

const analyticsMetrics = [
  {
    id: "sos",
    name: ($) => $.metrics["SOS"],
    accessor: (d) => d?.sos_average / 100,
    format: "percent",
    decimalPlaces: 1,
    toolTip: ($) => $.metrics["Average of your brands' page one share of shelf across all shelves."],
  },
  {
    id: "sos_organic",
    name: ($) => $.metrics["SOS Organic"],
    accessor: (d) => d?.sos_organic_average / 100,
    format: "percent",
    decimalPlaces: 1,
    toolTip: ($) => $.metrics["Average of your brands' page one organic share of shelf across all shelves."],
  },
  {
    id: "sov",
    name: ($) => $.metrics["SOV"],
    accessor: (d) => d?.sov_average / 100,
    format: "percent",
    decimalPlaces: 1,
    toolTip: ($) => $.metrics["Average of your brands' page one share of voice across all shelves."],
  },
  {
    id: "atf_sos",
    name: ($) => $.metrics["ATF SOS"],
    accessor: (d) => d?.atf_sos_average / 100,
    format: "percent",
    decimalPlaces: 1,
    toolTip: ($) => $.metrics["Average of your brands' above the fold share of shelf across all shelves."],
  },
  {
    id: "atf_sos_organic",
    name: ($) => $.metrics["ATF SOS Organic"],
    accessor: (d) => d?.atf_sos_organic_average / 100,
    format: "percent",
    decimalPlaces: 1,
    toolTip: ($) => $.metrics["Average of your brands' above the fold organic share of shelf across all shelves."],
  },
  {
    id: "atf_sov",
    name: ($) => $.metrics["ATF SOV"],
    accessor: (d) => d?.atf_sov_average / 100,
    format: "percent",
    decimalPlaces: 1,
    toolTip: ($) => $.metrics["Average of your brands' above the fold share of voice across all shelves."],
  },
  {
    id: "avg_position",
    name: ($) => $.metrics["Average Position"],
    accessor: (d) => d?.position_average,
    format: "number",
    decimalPlaces: 0,
    toolTip: ($) => $.metrics["Average of your brands' products' search result position across all shelves."],
  },
];

export function AnalyticsStatsPanel() {
  const { start, end } = useDates();
  const shelfStatsQuery = useFetch(
    ["shelf_stats"],
    "/api/shelf_stats/",
    {
      stats_by: "shelf",
      end: end.toISOString(),
      start: start.toISOString(),
      summary: true,
    },
    {
      select: (data) => data.data,
    },
  );

  return (
    <HStack
      maxWidth={"100%"}
      overflowX="auto"
      padding={"small"}
      className={css({
        "&>div": {
          flex: "1 1 150px",
          minWidth: "150px",
        },
      })}
    >
      {analyticsMetrics.map((metric) => (
        <Card key={metric.id}>
          <SummaryMetric metric={metric} data={shelfStatsQuery.data} loading={shelfStatsQuery.isLoading} />
        </Card>
      ))}
    </HStack>
  );
}
